import { physiqueAuthInstance } from '../../service/physique.service';
import { corporateAuthInstance } from '../../service/corporate.service';

const config = {
  transformRequest: [
    function (data, headers) {
      delete headers.Authorization;
      return data;
    },
    ...physiqueAuthInstance.defaults.transformRequest,
  ],
};

export const PhysiqueLoginService = {
  verify(data) {
    return physiqueAuthInstance.post('/common/verification', data, config);
  },
  authorize(data) {
    return physiqueAuthInstance.post('/common/oauth/token', data, config).then((res) => res.data);
  },
  register(data) {
    return physiqueAuthInstance.post('/common/registration', data, config).then((res) => res.data);
  },
  logout() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('');
      }, 500);
    });
  },
  signOn(data) {
    return physiqueAuthInstance.post('/common/sign-on', data, config).then((res) => res.data);
  },
};

export const CorporateLoginService = {
  verify(data) {
    return corporateAuthInstance.post('/corporate/verification', data);
  },
  authorize(data) {
    return corporateAuthInstance.post('/corporate/oauth/token', data).then((res) => res.data);
  },
  logout() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('');
      }, 500);
    });
  },
};
